import { Component, ChangeDetectionStrategy } from '@angular/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'product-cell-renderer',
  standalone: true,
  template: `
    <div class="productCell">
      <!-- <div class="image">
        <img [src]="getImageUrl(image, 60, 60, false)" [alt]="image" />
      </div> -->
      <div>
        <div>{{ value }}</div>
        <div class="stockCell">{{ category }}</div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .productCell {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .image {
        max-width: 100%;
        max-height: 100px;
        background-color: rgba(201, 201, 201, 0.2);
        border-radius: 8px;
        margin: 8px;
      }

      .image img {
        width: 60px;
        height: 60px;
      }

      .productCell div:first-child {
        font-weight: 500;
      }

      .productCell div {
        padding-bottom: 0;
        line-height: 1.5;
      }

      .productCell img {
        border-radius: 8px;
      }

      .stockCell {
        background-color: var(--color-bg-secondary);
        color: var(--color-text-secondary);
        width: fit-content;
        border: 1px solid #c0c0c057;
        border-radius: 6px;
        padding-top: 2px;
        margin-top: 4px;
        padding-right: 4px;
        padding-left: 4px;
        font-size: 12px;
      }
    `,
  ],
})
export class ProductCellRenderer implements ICellRendererAngularComp {
  public value: string = '';
  public image: string = '';
  public category: string = '';

  agInit(params: ICellRendererParams): void {
    this.value = params.data.part.partNumber;
    this.image = params.data.part.partNumber;
    this.category = params.data.part.toolType.toolFamily.name;
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.data.part.partNumber;
    this.image = params.data.part.partNumber;
    this.category = params.data.part.toolType.toolFamily.name;
    return true;
  }

  getImageUrl(partNumber: string,width: number, height: number, rotate: boolean): string {
    const options = [
      width ? `width=${width}` : null,
      height ? `height=${height}` : null,
      rotate ? 'rotate' : null,
    ].filter(Boolean).join(",");
    return `https://jtms.drillingllc.com/cdn/images/tools/${options}/${partNumber}.png`
  }
}
